import React from "react";
import ptBR from "antd/es/locale/pt_BR";
import dayjs from "dayjs";
import { ComponentInput, ComponentLine } from "../../styled";
import { Button, DatePicker, ConfigProvider, Flex, Input, Select, Radio, Checkbox, Alert } from 'antd';
import { CiExport, CiImport } from "react-icons/ci";

export default function OptionCredenciaisDeAcesso({
  selectedOptionCredenciais,
  handleRadioChangecredenciais,
  dadosCliente,
  dataCliente,
  info,
  onChangeEscolherProcuracaoDigital,
  onChangeEscolherComoCertificadoDigital,
  isProcuracaoDigital,
  isDataInicioVigencia,
  statusInput,
  setstatusInput,
  setdadosCliente,
  isDataTermicoVigencia,
  isCertificadoDigital,
  loadingDownloading,
  downloadCertificadoDigital,
  abrirModalImportCertificado,
  loading,
  onChangeEscolherAcessoRemoto,
  formatCPF,
}) {
  return (
    <>
      <div className="bgf5f5f5">
        <div className="padding10 margin-auto" style={{ textAlign: "center" }}>
          <Flex vertical gap="middle">
            <Radio.Group
              value={selectedOptionCredenciais}
              onChange={handleRadioChangecredenciais}
            >
              <Radio.Button value="certificado">
                Certificado Digital
              </Radio.Button>
              <Radio.Button value="codigos">Códigos de acesso</Radio.Button>
            </Radio.Group>
          </Flex>
        </div>

        {selectedOptionCredenciais === "certificado" && (
          <>
            <div style={{ padding: "10px" }}>
              <Alert
                description="Escolha a forma com que o Meu Contador Online
                                      deverá acessar as informações da empresa junto à
                                      Receita Federal do Brasil:"
                type="warning"
                showIcon
              />
            </div>

            <ComponentLine>
              <ComponentInput>
                <Checkbox
                  checked={dadosCliente.procuracaoDigital}
                  onChange={onChangeEscolherProcuracaoDigital}
                >
                  <strong>Procuração Digital</strong>
                </Checkbox>

                <Checkbox
                  checked={dadosCliente.certificadoCedido}
                  onChange={onChangeEscolherComoCertificadoDigital}
                >
                  <strong>Certificado Digital</strong>
                </Checkbox>
              </ComponentInput>
            </ComponentLine>

            {isProcuracaoDigital && (
              <>
                <ComponentLine>
                  {isDataInicioVigencia && (
                    <ComponentInput>
                      <p>Data Início Vigência</p>

                      <DatePicker
                        style={{ width: 180 }}
                        className="date-picker"
                        value={
                          dadosCliente.dataInicioProcuracaoDigital
                            ? dayjs(dadosCliente.dataInicioProcuracaoDigital)
                            : null
                        }
                        status={
                          statusInput === "dataInicioProcuracaoDigital"
                            ? "error"
                            : ""
                        }
                        onChange={(date) => {
                          const value = date ? date.toISOString() : null; // Atualize a data em formato ISO

                          setstatusInput(value === "" ? "error" : "");

                          setdadosCliente((prevState) => ({
                            ...prevState,
                            dataInicioProcuracaoDigital: value,
                          }));
                        }}
                        format="DD/MM/YYYY"
                      />
                    </ComponentInput>
                  )}
                  {isDataTermicoVigencia && (
                    <ComponentInput>
                      <p>Data Término Vigência</p>

                      <DatePicker
                        style={{ width: 180 }}
                        className="date-picker"
                        value={
                          dadosCliente.dataTerminoProcuracaoDigital
                            ? dayjs(dadosCliente.dataTerminoProcuracaoDigital)
                            : null
                        }
                        status={
                          statusInput === "dataTerminoProcuracaoDigital"
                            ? "error"
                            : ""
                        }
                        onChange={(date) => {
                          const value = date ? date.toISOString() : null;

                          setstatusInput(value === "" ? "error" : "");

                          setdadosCliente((prevState) => ({
                            ...prevState,
                            dataTerminoProcuracaoDigital: value,
                          }));
                        }}
                        format="DD/MM/YYYY"
                      />
                    </ComponentInput>
                  )}
                </ComponentLine>

                {isCertificadoDigital && (
                  <>
                    <ComponentLine>
                      <ComponentInput>
                        <p>
                          Carregue o arquivo do certificado digital de sua
                          empresa:
                        </p>
                        <div style={{ display: "flex" }}>
                          {dataCliente.length === 0 ? (
                            <></>
                          ) : (
                            <div>
                              <Button
                                className="bg-color"
                                onClick={() =>
                                  downloadCertificadoDigital(
                                    info.clienteId,
                                    dataCliente.files
                                  )
                                }
                                disabled={loadingDownloading}
                              >
                                {loadingDownloading ? (
                                  "Baixando..."
                                ) : (
                                  <span>
                                    <CiImport /> Baixar
                                  </span>
                                )}
                              </Button>
                            </div>
                          )}
                          <div>
                            <Button
                              className="bg-color"
                              onClick={abrirModalImportCertificado}
                            >
                              <CiExport />{" "}
                              {dataCliente.length > 0 ? "Trocar" : "Carregar"}
                            </Button>{" "}
                          </div>
                          <div>
                            <>
                              {loading ? (
                                <div>Carregando...</div>
                              ) : dataCliente.length > 0 ? (
                                dataCliente.map((filePath, index) => {
                                  const fileName = filePath.split("\\").pop();
                                  return (
                                    <div
                                      style={{
                                        position: "relative",
                                        top: "-5px",
                                        left: "5px",
                                      }}
                                    >
                                      <Alert
                                        message={fileName}
                                        type="success"
                                        showIcon
                                      />
                                    </div>
                                  );
                                })
                              ) : (
                                <div
                                  style={{
                                    position: "relative",
                                    top: "-5px",
                                    left: "5px",
                                  }}
                                >
                                  <Alert
                                    message="Nenhum certificado identificado."
                                    type="info"
                                    showIcon
                                  />
                                </div>
                              )}
                            </>
                          </div>
                        </div>
                      </ComponentInput>
                    </ComponentLine>

                    <ComponentLine>
                      <ComponentInput>
                        <p>Modalidade do Certificado</p>
                        <Select
                          placeholder="Selecione"
                          value={dadosCliente.certificadoModalidade}
                          status={
                            statusInput === "certificadoModalidade"
                              ? "error"
                              : ""
                          }
                          onChange={(value) => {
                            setstatusInput(value ? "" : "error"); // Checa se o valor é vazio ou null
                            setdadosCliente((prevState) => ({
                              ...prevState,
                              certificadoModalidade: value,
                            }));
                          }}
                          style={{ width: 240 }}
                          options={[
                            { value: "eCNPJ", label: "e-CNPJ Preferível" },
                            { value: "eCPF", label: "e-CPF" },
                            { value: "", label: "Selecione", disabled: true }, // Ajustado para valor vazio como default
                          ]}
                        />
                      </ComponentInput>

                      <ComponentInput>
                        <p>Tipo de Certificado</p>
                        <Select
                          placeholder="Selecione"
                          value={dadosCliente.certificadoTipo}
                          status={
                            statusInput === "certificadoTipo" ? "error" : ""
                          }
                          onChange={(value) => {
                            setstatusInput(value ? "" : "error");

                            setdadosCliente((prevState) => ({
                              ...prevState,
                              certificadoTipo: value,
                            }));
                          }}
                          style={{ width: 240 }}
                          options={[
                            { value: "A1", label: "Tipo A1" },
                            { value: "A3", label: "Tipo A3" },
                            {
                              value: "Selecione",
                              label: "Selecione",
                              disabled: true,
                            },
                          ]}
                        />
                      </ComponentInput>

                      <ComponentInput>
                        <p>Senha do Certificado</p>
                        <Input
                          placeholder="Senha do Certificado"
                          value={dadosCliente.certificadoSenha}
                          status={
                            statusInput === "certificadoSenha" ? "error" : ""
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            setstatusInput(value ? "" : "error");

                            setdadosCliente((prevState) => ({
                              ...prevState,
                              certificadoSenha: value,
                            }));
                          }}
                          style={{ width: 240 }}
                        />
                      </ComponentInput>

                      <ComponentInput>
                        <p>Expiração do Certificado</p>
                        <ConfigProvider locale={ptBR}>
                          <DatePicker
                            style={{ width: 180 }}
                            className="date-picker"
                            value={
                              dadosCliente.certificadoDataExpiracao
                                ? dayjs(dadosCliente.certificadoDataExpiracao)
                                : null
                            } // Certifique-se de passar um objeto dayjs
                            status={
                              statusInput === "certificadoDataExpiracao"
                                ? "error"
                                : ""
                            }
                            onChange={(date) => {
                              setstatusInput(date ? "" : "error");

                              setdadosCliente((prevState) => ({
                                ...prevState,
                                certificadoDataExpiracao: date
                                  ? date.toISOString()
                                  : null, // Atualize a data em formato ISO
                              }));
                            }}
                            format="DD/MM/YYYY"
                          />
                        </ConfigProvider>
                      </ComponentInput>
                    </ComponentLine>
                  </>
                )}
              </>
            )}

            <br />

            <ComponentLine>
              <ComponentInput>
                <Checkbox
                  checked={dadosCliente.acessoContador}
                  onChange={onChangeEscolherAcessoRemoto}
                >
                  <strong>Acesso Remoto</strong>
                </Checkbox>
              </ComponentInput>
            </ComponentLine>
          </>
        )}

        {selectedOptionCredenciais === "codigos" && (
          <>
            <ComponentLine>
              <ComponentInput>
                <p>Código Acesso SN</p>
                <Input
                  placeholder="Código Acesso SN"
                  style={{ width: 190 }}
                  value={dadosCliente.codigoAcessoSN}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoAcessoSN: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                />
              </ComponentInput>

              <ComponentInput>
                <p>CPF de Acesso SN</p>
                <Input
                  placeholder="CPF de Acesso SN"
                  style={{ width: 190 }}
                  value={formatCPF(dadosCliente.cpfAcessoSN)}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      cpfAcessoSN: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                />
              </ComponentInput>

              <ComponentInput>
                <p>Penúltimo Recibo IRPF</p>
                <Input
                  placeholder="Penúltimo Recibo IRPF"
                  style={{ width: 190 }}
                  value={dadosCliente.codigoReciboIRPF1}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoReciboIRPF1: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                />
              </ComponentInput>

              <ComponentInput>
                <p>Último Recibo IRPF</p>
                <Input
                  placeholder="Último Recibo IRPF"
                  style={{ width: 190 }}
                  value={dadosCliente.codigoReciboIRPF2}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoReciboIRPF2: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                />
              </ComponentInput>

              <ComponentInput>
                <p>Código Acesso Gov</p>
                <Input
                  placeholder="Código Acesso Gov"
                  style={{ width: 190 }}
                  value={dadosCliente.codigoAcessoGov}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoAcessoGov: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                />
              </ComponentInput>
            </ComponentLine>

            <ComponentLine>
              <ComponentInput>
                <p>Senha Acesso Gov</p>
                <Input
                  placeholder="Senha Acesso Gov"
                  style={{ width: 190 }}
                  value={dadosCliente.senhaAcessoGov}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      senhaAcessoGov: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                />
              </ComponentInput>
              <ComponentInput>
                <p>Código Acesso Municipal</p>
                <Input
                  placeholder="Código Acesso Municipal"
                  value={dadosCliente.codigoAcessoNFSe}
                  style={{ width: 190 }}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoAcessoNFSe: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                />
              </ComponentInput>

              <ComponentInput>
                <p>Senha Acesso Municipal</p>
                <Input
                  placeholder="Senha Acesso Municipal"
                  value={dadosCliente.senhaAcessoNFSe}
                  style={{ width: 190 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      senhaAcessoNFSe: value, // Use 'e.target.value' para obter o valor do input
                    }));
                  }}
                />
              </ComponentInput>

              <ComponentInput>
                <p>Código Acesso Estadual</p>
                <Input
                  placeholder="Código Acesso Estadual"
                  value={dadosCliente.codigoAcessoNFe}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoAcessoNFe: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                  style={{ width: 190 }}
                />
              </ComponentInput>

              <ComponentInput>
                <p>Senha Acesso Estadual</p>
                <Input
                  placeholder="Senha Acesso Estadual"
                  value={dadosCliente.senhaAcessoNFe}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      senhaAcessoNFe: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                  style={{ width: 190 }}
                />
              </ComponentInput>
            </ComponentLine>

            <ComponentLine>
              <ComponentInput>
                <p>Código Acesso eCAC</p>
                <Input
                  placeholder="Código Acesso eCAC"
                  value={dadosCliente.codigoAcessoECAC}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoAcessoECAC: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                  style={{ width: 190 }}
                />
              </ComponentInput>

              <ComponentInput>
                <p>Senha Acesso eCAC</p>
                <Input
                  placeholder="Senha Acesso eCAC"
                  value={dadosCliente.senhaAcessoECAC}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      senhaAcessoECAC: e.target.value, // Use 'e.target.value' para obter o valor do input
                    }))
                  }
                  style={{ width: 190 }}
                />
              </ComponentInput>

              <ComponentInput>
                <p>Tipo Acesso eCAC</p>
                <Select
                  placeholder="Selecione"
                  value={dadosCliente.tipoAcessoECAC} // Mantém o valor da API como selecionado
                  onChange={(value) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      tipoAcessoECAC: value, // Atualiza o tipo de empresa com o valor selecionado
                    }))
                  }
                  style={{ width: 190 }}
                  options={[
                    {
                      value: "codigo de acesso",
                      label: "Código de Acesso",
                    },
                    {
                      value: "procuracao eletronica",
                      label: "Procuração Eletrônica",
                    },
                    {
                      value: "Selecione",
                      label: "Selecione",
                      disabled: true,
                    },
                  ]}
                />
              </ComponentInput>

              <ComponentInput>
                <p>Código Acesso Empregador Web</p>
                <Input
                  placeholder="Código Acesso Empregador Web"
                  value={dadosCliente.codigoAcessoEW}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      codigoAcessoEW: e.target.value, // Atualiza o tipo de empresa com o valor selecionado
                    }))
                  }
                  style={{ width: 190 }}
                />
              </ComponentInput>

              <ComponentInput>
                <p>Senha Acesso Empregador Web</p>
                <Input
                  placeholder="Senha Acesso Empregador Web"
                  value={dadosCliente.senhaAcessoEW}
                  onChange={(e) =>
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      senhaAcessoEW: e.target.value, // Atualiza o tipo de empresa com o valor selecionado
                    }))
                  }
                  style={{ width: 190 }}
                />
              </ComponentInput>
            </ComponentLine>
          </>
        )}
      </div>
    </>
  );
}
